import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconBack20Style0 = cosmosIconCss;

const CosmosIconBack20$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBack20 extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8610eefab20996d00d2254d4d90f3b3139c3037b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e98f5be1d9cbd2a088aed29ef3a857a70b6c6ad6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd776d0be0db4a8f7a31eb5e22a7111851269305b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 6.472h4.628a5.11 5.11 0 0 1 5.162 4.824 4.852 4.852 0 0 1-1.362 3.562 5 5 0 0 1-2.841 1.493.509.509 0 0 1-.587-.5v-.532a.51.51 0 0 1 .425-.493c.73-.137 1.4-.49 1.926-1.015a3.323 3.323 0 0 0 .939-2.473 3.6 3.6 0 0 0-3.662-3.362H9v2.3a.5.5 0 0 1-.854.352L5.114 7.576a.5.5 0 0 1 0-.706l3.033-3.024A.5.5 0 0 1 9 4.2v2.272Zm.19 6.846c.312-.3.738-.453 1.169-.418a1.5 1.5 0 0 1 1.62 1.567V15.7a1.5 1.5 0 0 1-1.62 1.571A1.507 1.507 0 0 1 8.732 15.7v-1.229c-.02-.432.147-.852.459-1.153Zm1.594 2.361c0 .349-.143.531-.425.531-.282 0-.431-.187-.431-.531v-1.187c0-.344.143-.532.431-.532.288 0 .425.182.425.532v1.187Zm-2.536-1.427c0 .7-.38 1.02-1.1 1.48-.22.132-.43.279-.63.44h1.46a.278.278 0 0 1 .3.3v.42a.278.278 0 0 1-.3.3h-2.54a.278.278 0 0 1-.3-.3v-.14a2.016 2.016 0 0 1 1.15-1.64c.62-.4.75-.49.75-.73a.327.327 0 0 0-.35-.37.315.315 0 0 0-.33.24.3.3 0 0 1-.3.24h-.6a.268.268 0 0 1-.3-.32 1.449 1.449 0 0 1 1.59-1.28 1.323 1.323 0 0 1 1.5 1.36Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconBack20Style0; }
}, [1, "cosmos-icon-back-20", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-back-20"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-back-20":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBack20$1);
            }
            break;
    } });
}

const CosmosIconBack20 = CosmosIconBack20$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBack20, defineCustomElement };
